import _ from 'lodash'
import config from '../configs/config'
const {
  packageRatesReply,
  discoveryApiUrl,
  brandConfig
} = config

const discovery = {
  checkSearchIsDiscoveryPrimed: () => {
    return (dispatch, getState) => {
      if (!_.get(brandConfig, 'secure.hasFeatures.availability.hasPriceFinder', false)) {
        return dispatch({
          type: 'DISCOVERY_PRIMED',
          primed: false
        })
      }
      const { rooms = [], checkinDate, checkoutDate } = _.get(packageRatesReply, 'meta.context.roomRates')
      const searchFormId = _.get(packageRatesReply, 'meta.context.searchFormId') || _.get(packageRatesReply, 'meta.context.venueCode')
      const searchedPartyComp = rooms.reduce((partyComp, room) => {
        partyComp.adults += room.adults
        partyComp.children += room.children
        partyComp.infants += room.infants
        return partyComp
      }, { adults: 0, children: 0, infants: 0, babies: 0 })
      fetch(`${discoveryApiUrl}primeStatus?brand=${brandConfig.id}&partyComposition[adults]=${searchedPartyComp.adults}&partyComposition[children]=${searchedPartyComp.children}&partyComposition[infants]=${searchedPartyComp.infants}&partyComposition[babies]=${searchedPartyComp.babies}&checkinDate=${checkinDate}&checkoutDate=${checkoutDate}&searchFormId=${searchFormId}`)
        .then(response => response.json())
        .then(data => {
          dispatch({
            type: 'DISCOVERY_PRIMED',
            primed: data === true
          })
        })
    }
  }
}

export default discovery
